import { FC, useState, useCallback } from 'react';
import ChatBubble from './components/ChatBubble';
import ChatPanel from './components/ChatPanel';
import { useChatV2 } from '../AIChatV2/hooks/useChatV2';

const ChatWidget: FC = () => {
  const [isOpen, setIsOpen] = useState(false);

  const {
    messages,
    isStreaming,
    error,
    insights,
    unreadInsightCount,
    dismissInsight,
    sendMessage,
    clearHistory,
    clearError,
  } = useChatV2();

  const toggleChat = useCallback(() => {
    setIsOpen((prev) => !prev);
  }, []);

  const closeChat = useCallback(() => {
    setIsOpen(false);
  }, []);

  return (
    <>
      <ChatBubble
        onClick={toggleChat}
        hasNotification={!isOpen && unreadInsightCount > 0}
        notificationCount={unreadInsightCount}
      />
      <ChatPanel
        isOpen={isOpen}
        onClose={closeChat}
        messages={messages}
        isStreaming={isStreaming}
        error={error}
        insights={insights}
        onSendMessage={sendMessage}
        onClearHistory={clearHistory}
        onDismissInsight={dismissInsight}
        onClearError={clearError}
      />
    </>
  );
};

export default ChatWidget;
